import { Component, TemplateRef, ViewChild, inject, signal } from '@angular/core';

import { NavigationComponent } from '@camelot/menu';
import { MissionType } from '@camelot/services';

import { CamPlanningMenuService } from '../../services/form/menu/planning-menu.service';

interface MissionTypeItem {
  missionType: MissionType;
  name: string;
  id: string;
}

@Component({
  host: { 'data-cid': 'input-choice-template' },
  selector: '',
  templateUrl: './mission-input-template.component.html',
  imports: [NavigationComponent],
})
export class InputChoiceTemplateComponent {
  @ViewChild('choiceTemplate', { static: true }) choiceTemplate!: TemplateRef<any>;

  private readonly _menuService = inject(CamPlanningMenuService);

  public menu = this._menuService.getMissionTypeNavMenu((type: MissionType) => this.changeSelection(type));
  public selected = signal<MissionType | null>(null);

  getTemplate() {
    return this.choiceTemplate;
  }

  public changeSelection(selected: MissionType) {
    this.selected.set(selected);
  }
  public filteredItems(data: MissionTypeItem[]) {
    const currentSelection = this.selected();
    if (!currentSelection) {
      return data;
    }
    return data.filter(item => item.missionType === currentSelection);
  }
}
